"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Check = void 0;
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var button_1 = require("@chakra-ui/button");
var layout_1 = require("@chakra-ui/layout");
var layout_2 = require("../../../common/layout");
var useApplyCheck_1 = require("./useApplyCheck");
var PageLoading_1 = require("../../../common/loading/PageLoading");
var useSetMeta_1 = require("../../../common/hooks/useSetMeta");
var Check = function () {
    var LineLoginError = (0, useApplyCheck_1.useApplyCheck)().LineLoginError;
    var navigate = (0, react_router_1.useNavigate)();
    var backButton = function () {
        navigate("/main/apply");
    };
    (0, useSetMeta_1.useSetMeta)("LINE認証");
    return (react_1.default.createElement(react_1.default.Fragment, null, LineLoginError ? (react_1.default.createElement(layout_2.Layout, { headerUrl: "", isHeader: true, isFooter: true },
        react_1.default.createElement(layout_1.Container, { maxW: "container.xl", textAlign: "center", py: "2em" },
            react_1.default.createElement(layout_1.Text, { fontSize: "1.6rem" }, "LINE\u8A8D\u8A3C\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002"),
            react_1.default.createElement(button_1.Button, { mt: "1rem", size: "lg", height: "4rem", fontSize: "1.6rem", minW: "10rem", onClick: function () {
                    backButton();
                } }, "\u623B\u308B")))) : (react_1.default.createElement(PageLoading_1.PageLoading, null))));
};
exports.Check = Check;
